export class RefundItemUnitDto {
  constructor(data) {
    this.assignee = data.assignee;
    this.id = data.id;
    this.is_refunded = data.is_refunded;
    this.package = data.package;
    this.product = data.package;
  }
}

export class RefundDto {
  constructor(dto) {
    this.id = dto.id;
    this.approve_date = dto.approve_date;
    this.amount = dto.amount;

    /** @type {RefundItemUnitDto[]} */
    this.item_units = dto.item_units;
    this.check_number = dto.check_number;
    this.is_check_type = dto.is_check_type;
  }
}
